import React, { useRef } from "react";
import { VideoPlayer as VideoPlayerFragment } from "@sonder/ui/source/styled/fragments/VideoPlayer";

interface VideoPlayerProps {
  controls?: boolean;
  poster?: string;
  src?: string;
}

export const VideoPlayer = ({
  controls = true,
  poster = "",
  src,
}: VideoPlayerProps) => {
  const videoRef = useRef(null);
  return (
    <>
      <VideoPlayerFragment
        controls={controls}
        poster={poster}
        ref={videoRef}
        src={src}
      />
    </>
  );
};
